import type { AxiosError } from 'axios';

/** Pull a human message out of an Axios error, falling back to a default. */
export function extractApiError(error: unknown, fallback: string): string {
  const axiosError = error as AxiosError<{ message?: string | string[] }> | undefined;
  const data = axiosError?.response?.data;
  if (data?.message) {
    return Array.isArray(data.message) ? data.message.join(', ') : data.message;
  }
  return fallback;
}

// Suggested destination folders for DOCUMENT upload blocks. Folders are plain
// string labels in the documents module, so these are conveniences — HR can type
// any folder name. The actual routing happens in the submission runtime (HW-580).
export const SUGGESTED_DOCUMENT_FOLDERS = [
  'Pre-boarding',
  'Onboarding',
  'Contracts',
  'Personal',
  'Identity',
];
